import { useState, useCallback, Dispatch, SetStateAction } from 'react'
import { isPlainObject, castArray } from 'lodash-es'

type RequireId = {
  id: string
}

type ObjectOrPrimitive<T> = T extends object ? Required<RequireId> & T : T

function useMultiSelect<T>(
  initial: ObjectOrPrimitive<T>[],
): [
  ObjectOrPrimitive<T>[],
  (item: ObjectOrPrimitive<T>) => ObjectOrPrimitive<T>[],
  Dispatch<SetStateAction<ObjectOrPrimitive<T>[]>>,
] {
  const [value, setValue] = useState<ObjectOrPrimitive<T>[]>(initial)
  const valueArray = castArray<ObjectOrPrimitive<T>>(value)

  return [
    valueArray,
    useCallback(
      (item: ObjectOrPrimitive<T>) => {
        let newValue
        if (isPlainObject(item)) {
          item
          newValue = valueArray.find(
            x => (x as RequireId).id === (item as RequireId).id,
          )
            ? valueArray.filter(
                x => (x as RequireId).id !== (item as RequireId).id,
              )
            : [...valueArray, item]
        } else {
          newValue = valueArray.includes(item)
            ? valueArray.filter(x => x !== item)
            : [...valueArray, item]
        }
        setValue(newValue)
        return newValue
      },
      [valueArray],
    ),
    setValue,
  ]
}
export default useMultiSelect
